import { Checkbox, Divider, Drawer, message, Select, Slider } from "antd";
import React, { useState } from "react";
import EditorPanelHeading from "../../UI/EditorPanelHeading";
import { getColor } from "../../../utils/ConvertCSS";
import { useTemplate } from "../../../utils/Template";
import ColourPicker from "../../../globals/styles/ColourPicker";
import { tt_name_block_warning } from "../../../utils/Utils";
import SliderInput from "../../UI/SiderInput";
import BMInput from "../../comps/BMInput";

export default function BuiltInEmpty(props) {

    const { edit = false, close = () => { }, saveItem = () => { }, deleteItem = () => { }, id = 0 } = props;
    const [content, setContent] = useState(props.content);
    const [template,] = useTemplate();

    const setData = (_data) => {
        setContent({ ...content, "data": _data })
    }

    // Component agnostic
    const {
        name = "",
        container = true,
        data = {},
        date_changed = 0
    } = content;

    
    const save = () => {
        if (!name) {
            let _name = prompt(tt_name_block_warning);
            if (_name) {
                close();
                saveItem(id, { ...content, "name": _name });
            } else {
                return;
            }
        } else {
            close();
            saveItem(id, { ...content })
        }
    }

    const trash = () => {
        deleteItem(id);
        close();
    }

    const drawRender = () => {
        return (
            <div id={"bm-" + id} className={(container) ? "preview-container" : ""}>
               
            </div>
        )
    }

  

    const drawForm = () => {
        return (
            <>
                <EditorPanelHeading hide_visibility hide_container hide_date menus={props.menus} close={close} trash={() => { message.error("Can't delete built-in components")}} save={save} content={content} setContent={setContent} date_changed={date_changed} name={name} />
               
                <div className="shim" /> <div className="shim" />

            </>
        )
    }

    return (
        <>
            <Drawer bodyStyle={{ "backgroundColor": "#f5f5f5", "overflowX": "hidden" }} closable={false} width={300} onClose={() => close(true)} open={edit}>
                {drawForm()}
            </Drawer>
            {drawRender()}
        </>
    )

}